/* ============================================================
   RM-FIXES — Rozwojowa Mama CRO hotfix bundle
   Added 2026-08-05 (Claude/CRO work with Marielle). Self-contained:
   this file does NOT modify any agency file.

   Loaded from snippets/doc-head-core.liquid with `defer`, BEFORE main.js.

   (1) Carousel null-guard — contains the slider TypeError that showed
       in 36.6% of Clarity sessions.
   (2) eKomi fallback — hides the raw-ID placeholder only.
   (3) Cart-drawer cross-sell arrows — (3a) unhides the nav arrows that
       main.css hides in the drawer; v4 2026-08-06: buttons shrunk to
       26px with 18px chevrons and vertically centered on the
       "Zobacz również" heading line (v3 36px/26px boxes sat visibly
       higher and larger than the 14px heading — Marielle flagged it).
       Both states always navy; disabled is dimmed navy (theme default
       styled disabled as a red circle). (3b) click fallback for
       carousels initialised while hidden (scroll-dead smooth scroll
       in Chrome) — scrolls instantly if the native handler did not
       move the slider, which also heals it.
   (4) Free-shipping bar colors — brand navy for the progress bar,
       green once the 299 zł threshold is met (theme setting had the
       generic #171717 and no explicit met color).
   ============================================================ */
(function rmFixes() {
  'use strict';

  /* ---- (2) eKomi raw-ID placeholder ---- */
  try {
    var st = document.createElement('style');
    st.setAttribute('data-rm-fixes', 'ekomi');
    st.textContent = '.ekomi-product-widget-identifier{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) { /* no-op */ }

  /* ---- (3a) drawer cross-sell arrows: heading-aligned, always navy ---- */
  try {
    var st3 = document.createElement('style');
    st3.setAttribute('data-rm-fixes', 'drawer-nav');
    st3.textContent = [
      '.cart-item-upsells .slider-nav{display:flex !important;gap:2px;position:static !important;align-self:center;}',
      '.cart-item-upsells .slider-nav__btn, .cart-item-upsells .slider-nav__btn[disabled]{position:static !important;top:auto !important;left:auto !important;right:auto !important;transform:none !important;width:26px;height:26px;padding:0;display:flex;align-items:center;justify-content:center;background:transparent !important;border:0 !important;box-shadow:none !important;color:#001c84 !important;cursor:pointer;}',
      '.cart-item-upsells .slider-nav__btn svg, .cart-item-upsells .slider-nav__btn[disabled] svg{width:18px;height:18px;stroke:#001c84 !important;color:#001c84 !important;pointer-events:none;}',
      '.cart-item-upsells .slider-nav__btn:disabled{opacity:.45;cursor:default;}'
    ].join('');
    (document.head || document.documentElement).appendChild(st3);
  } catch (e) { /* no-op */ }

  /* ---- (4) free-shipping bar brand colors ---- */
  try {
    var st4 = document.createElement('style');
    st4.setAttribute('data-rm-fixes', 'fsbar');
    st4.textContent = [
      '.free-shipping-bar{--free-shipping-bar-color:#001c84 !important;}',
      '.free-shipping-bar[data-free-shipping-progress="1"]{--free-shipping-bar-color:#09a22b !important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(st4);
  } catch (e) { /* no-op */ }

  /* ---- (1) slider guard ---- */
  function isSlider(C) {
    try {
      return !!(C && C.prototype && typeof C.prototype.getSlideVisibility === 'function');
    } catch (e) { return false; }
  }

  function wrap(orig, key) {
    var fn = function () {
      try {
        return orig.apply(this, arguments);
      } catch (err) {
        if (!window.__rmFixWarned) {
          window.__rmFixWarned = true;
          console.warn('[rm-fixes] slider error contained:', err);
        }
        return undefined;
      }
    };
    try { Object.defineProperty(fn, 'name', { value: key, configurable: true }); } catch (e) { /* no-op */ }
    return fn;
  }

  function guard(C) {
    try {
      var proto = C.prototype;
      var stop = window.HTMLElement ? window.HTMLElement.prototype : null;
      while (proto && proto !== stop && proto !== Object.prototype) {
        if (!Object.prototype.hasOwnProperty.call(proto, '__rmGuarded')) {
          Object.defineProperty(proto, '__rmGuarded', { value: true, enumerable: false });
          Object.getOwnPropertyNames(proto).forEach(function (key) {
            if (key === 'constructor') return;
            var d;
            try { d = Object.getOwnPropertyDescriptor(proto, key); } catch (e) { return; }
            if (!d || typeof d.value !== 'function' || !d.writable || !d.configurable) return;
            d.value = wrap(d.value, key);
            try { Object.defineProperty(proto, key, d); } catch (e) { /* no-op */ }
          });
        }
        proto = Object.getPrototypeOf(proto);
      }
    } catch (e) { /* no-op */ }
  }

  try {
    var ce = window.customElements;
    if (ce && typeof ce.define === 'function' && !ce.__rmPatched) {
      var nativeDefine = ce.define.bind(ce);
      ce.define = function (name, ctor, options) {
        try { if (isSlider(ctor)) guard(ctor); } catch (e) { /* no-op */ }
        return nativeDefine(name, ctor, options);
      };
      ce.__rmPatched = true;
    }
  } catch (e) { /* no-op */ }

  function sweep() {
    try {
      var seen = {};
      document.querySelectorAll('*').forEach(function (el) {
        var tag = el.tagName.toLowerCase();
        if (tag.indexOf('-') === -1 || seen[tag]) return;
        seen[tag] = 1;
        var C = window.customElements.get(tag);
        if (isSlider(C)) guard(C);
      });
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  window.addEventListener('load', sweep);

  /* ---- (3b) carousel nav-arrow scroll fallback ---- */
  try {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[name="prev"], button[name="next"]') : null;
      if (!btn || !btn.classList.contains('slider-nav__btn')) return;
      var host = btn.closest('carousel-slider');
      if (!host) return;
      var sl = host.slider || host.querySelector('.slider');
      if (!sl || sl.scrollWidth <= sl.clientWidth + 5) return;
      var before = sl.scrollLeft;
      setTimeout(function () {
        try {
          if (Math.abs(sl.scrollLeft - before) > 2) return; /* native handler worked */
          var span = (host.slidesToScroll || 1) * (host.slideSpan || 0);
          if (!span || span !== span) {
            var items = host.querySelectorAll('.slider__item');
            span = items.length > 1 ? Math.abs(items[1].offsetLeft - items[0].offsetLeft) : sl.clientWidth;
          }
          var dir = btn.name === 'next' ? 1 : -1;
          if (document.dir === 'rtl') dir = -dir;
          var prevBehavior = sl.style.scrollBehavior;
          sl.style.scrollBehavior = 'auto';
          sl.scrollLeft = before + dir * span;
          sl.style.scrollBehavior = prevBehavior;
          if (!window.__rmNavFixUsed) {
            window.__rmNavFixUsed = true;
            console.warn('[rm-fixes] nav-arrow fallback engaged (carousel was scroll-dead)');
          }
        } catch (err) { /* no-op */ }
      }, 250);
    }, true);
  } catch (e) { /* no-op */ }
})();
